import { latLng, icon } from "leaflet";
import { mapState } from 'vuex';
import L from "leaflet";
import { processRecordsOne, processRecordsTwo } from '@/utils';

export default {
  data: () => ({
    // center: latLng(5.047269, -73.083070),
    center: latLng(10.85189, -74.87629),
    // variable que almacena el zoom actual
    currentZoom: 11.5,
    // variable que almacena la coordenada del centro del mapa
    currentCenter: latLng(5.047269, -73.083070),
    // objeto que almacena el mapa
    map: null,
    // configuracion del mapa
    mapOptions: {
      zoomSnap: 0.5
    },
    // valor del nivel de acercamiento del mapa
    zoom: 13,
    // icono del marcador leaflet
    icon: icon({
      iconUrl: require('@/assets/marker-icon.png'),
      shadowUrl: require('@/assets/marker-shadow.png'),
      iconSize: [25, 37],
      iconAnchor: [16, 37]
    }),
    // eatdo con los bound del mapa
    bounds: null,
    // eatdo para un polygono
    polygon: null,
    // color del polygono
    polygonColor: '#F44336',
    // opciones para el control de pantalla completa
    fullscreenOptions: {
      title: {
        'false': 'Activar el modo pantalla completa',
        'true': 'Salir del modo pantalla completa',
      },
    },
    // propieda con el zoom por defecto a una coordenada manual
    pointDetailZoom: 13,
    // estado que almacena el control de capas WMS
    wmsControl: null,
    // propiedad que almacena el listado de las capas del mapa
    layerControl: null,
    // propiedad que indica si el mapa esta lista
    mapReady: false,
    // opciones para el plugin de medida
    measureOptions: {
      primaryLengthUnit: 'meters',
      secondaryLengthUnit: 'kilometers',
      primaryAreaUnit: 'hectares',
      locale: 'es',
      activeColor: '#FF9800',
      completedColor: '#F44336',
      //  control position
      position: 'topleft',
    },
    // estado con las capas vetoriales que se pueden cargar en el mapa
    vectorLayers: [],
  }),

  computed: {
    ...mapState('geos', ['layers', 'markers']),
    ...mapState('cadastral', [
      'economicDestinations',
      'constructionUses',
      'typologyUses',
      'physicalZones',
      'economicZones',
    ])
  },

  methods: {
    // metodo que se lanza cuando el zoom se actualiza
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    // metodo que se lanza cuando el centro se actualiza
    centerUpdate(center) {
      this.currentCenter = center;
    },
    // metodo que se lanza cuando el
    lefletMapReady() {
      this.map = this.$refs.myMap.mapObject;
      setTimeout(() => {
        this.map.invalidateSize();
      }, 0);
      // setare objeto del controll de capas
      this.layerControl = this.$refs.lyControl.mapObject;
      this.mapReady = true;
    },
    // cuando un polygono esta listo
    polygonReady() {
      this.polygon = this.$refs.polygon.mapObject;
      this.bounds = this.polygon._bounds;
      setTimeout(() => {
        if ('_northEast' in this.bounds && '_southWest' in this.bounds) {
          this.map.fitBounds(this.bounds);
        }
      }, 100);
    },
    // metodo para enficar el poligono opera con el control
    focusProperty() {
      this.map.fitBounds(this.bounds);
    },
    // metodo para cambiar el zoom y extension del mapa por medio de marcadores
    markerExtend(markerName) {
      const marker = this.markers[markerName];
      // cambiar el centro y el zoom del mapa
      this.center = latLng(marker.lat, marker.lng);
      this.zoom = marker.zoom;
    },
    // metodo para conseguir la informacion wms
    async getFeatureInfo(event, layer, wmsUrl, fields) {
      // SI la capa es nula buscar la capa superpuesta con el
      // indice más alto en le mapa
      if (layer === null) {
        let activeOverlay = null;
        let zIndex = 0;
        this.layerControl._layers.forEach((x) => {
          if (x.overlay && this.map.hasLayer(x.layer) && x.layer.options.zIndex > zIndex) {
            activeOverlay = x.layer;
            zIndex = x.layer.options.zIndex;
          }
        });
        // si no esta habilitado el dibujo consultar el serviscio WMS
        if (activeOverlay === null) return;
        // asignar el nombre de la capa
        layer = activeOverlay.wmsParams.layers;
      }
      
      const point = this.map.latLngToContainerPoint(event.latlng);
      const bounds = this.map.getBounds();
      const size = this.map.getSize();
      
      // Construcción de la URL de GetFeatureInfo
      const params = {
        SERVICE: "WMS",
        VERSION: "1.1.1",
        REQUEST: "GetFeatureInfo",
        TRANSPARENT: "true",
        QUERY_LAYERS: layer,
        LAYERS: layer,
        INFO_FORMAT: "application/json", // También puedes usar "text/html" o "text/plain"
        FEATURE_COUNT: 10,
        X: Math.round(point.x),
        Y: Math.round(point.y),
        SRS: "EPSG:4326",
        WIDTH: size.x,
        HEIGHT: size.y,
        BBOX: `${bounds.getWest()},${bounds.getSouth()},${bounds.getEast()},${bounds.getNorth()}`,
      };

      if (fields) {
        params['PROPERTYNAME'] = fields.join(',')
      }

      const url = `${wmsUrl}?${new URLSearchParams(params).toString()}`;
      try {
        const response = await fetch(url, {
          mode: "cors"
        });
        const data = await response.json();
        console.log('Respuesta Feature Info', data);
        const estates = data.features;
        let strTemp = `<b style="color:red">Capa: ${layer}</b><br>`;
        for (let index = 0; index < estates.length; index++) {
          const estate = estates[index];
          let recordsOne = '';
          if (fields.includes('registros_1')) {
            const recordsOneData = JSON.parse(estate.properties.registros_1);
            processRecordsOne(recordsOneData, this.economicDestinations);
            recordsOne = `
            <table class="featureInfo">
              <caption class="featureInfo">Registros 1</caption>
              <tr>
                ${Object.keys(recordsOneData).map((x) => `<th>${x}</th>`).join('')}
              </tr>
              <tr>
              ${Object.values(recordsOneData).map((x) => `<td>${x}</td>`).join('')}
              </tr>
            </table>
            `
          }
          let recordsTwo = '';
          if (fields.includes('registros_2')) {
            const recordsTwoData = JSON.parse(estate.properties.registros_2);
            if (recordsTwoData.length > 0) {
              const firtsRecord = recordsTwoData[0];
              // procesar los datos de R"
              processRecordsTwo(recordsTwoData,
                this.constructionUses,
                this.typologyUses,
                this.physicalZones,
                this.economicZones);
              // iterar sobre los registros 2
              const itemsR2 = [];
              for (let indexR2 = 0; indexR2 < recordsTwoData.length; indexR2++) {
                const element = recordsTwoData[indexR2];
                itemsR2.push(`
                <tr>
                ${Object.values(element).map((x) => `<td>${x}</td>`).join('')}
                </tr>
                `)
              }
              recordsTwo = `
              <table class="featureInfo">
                <caption class="featureInfo">Registros 2</caption>
                <tr>
                  ${Object.keys(firtsRecord).map((x) => `<th>${x}</th>`).join('')}
                </tr>
                ${itemsR2.join('')}
              </table>
              `
            }
            
          }
          strTemp += `
          <b>Predio ${index + 1}</b><br>
          <div style="padding-bottom: 5px;">
            <b>NPN:</b> <span class="mr-2">${estate.properties.codigo}</span>
            <a class="ark-lf-button" target="_blank" href='/search?code=${estate.properties.codigo}'>Buscar</a><br>
            </div>
            <div style="padding-bottom: 10px;">
            <b>NPN anterior:</b> <span class="mr-2">${estate.properties.codigo_ant}</span>
            <a class="ark-lf-button" target="_blank" href='/search?code=${estate.properties.codigo_ant}'>Buscar</a><br>
            ${recordsOne}
            ${recordsTwo}
          </div>
          `;
          
        }
        if (estates.length === 0) strTemp = 'No hubo coincidencias';
        // Puedes mostrar los datos en un popup, modal o cualquier otro componente.
        L.popup()
        .setLatLng(event.latlng)
        .setContent(strTemp)
        // .setContent(`<b>Coordenadas:</b> ${event.latlng.lat}, ${event.latlng.lng}`)
        .openOn(this.map); // Se añade al mapa
      } catch (error) {
        console.error("Error en GetFeatureInfo:", error);
      }
    },
  }
}